import React from "react";
import EczaciKimlikKartForm from "../../component/EczaciKimlikKartForm";
import Footer from "../../component/Footer";
import "./EczaciKimlikKart.css";
import {VirtualHost} from "../../constants";
import {resourcePrefixType} from "../../util/Enums";

function EczaciKimlikKart() {
  return (
    <div>
      <section className="u-align-center u-clearfix u-section-1" id="sec-2548">
        <div className="u-clearfix u-sheet u-sheet-1">
          <h1 className="u-custom-font u-font-oswald u-text u-text-default u-text-1">
            {VirtualHost.companyName} Nedir?
          </h1>
          <p className="u-text u-text-2">
              {"tebeczacikart" === VirtualHost.resourcePrefix &&
                  "Eczacı Kart, eczacılarımızın her platformda mesleki temsil gücünün " +
                  "arttırılması, eczane ekonomisine katkı sağlanması, bireysel ve " +
                  "ticari harcamalarında avantajlar sunması için çalışan bir sadakat platformudur."
              }

              {"optikkart" === VirtualHost.resourcePrefix &&
                  "Optik Kart, üyelerimizin her alanda mesleki temsil gücünü ön plana çıkaran, işletme ve aile ekonomisine katkı sağlayan bir sadakat platformudur."
              }
          </p>
          <p className="u-text u-text-2">
              {resourcePrefixType.tebeczacikart === VirtualHost.resourcePrefix &&
                  "Mesleki bilinirliği ve temsil gücünü ön plana çıkarır, eczane ekonomisine katkı sağlar, bireysel harcamalara ve aile ekonomisine avantajlar sunar."
              }

              {resourcePrefixType.optikkart === VirtualHost.resourcePrefix &&
                  "Optik Kart ayrıcalığı ile yeme içmeden giyime, marketten kırtasiyeye, elektronikten beyaz eşyaya, akaryakıttan sağlığa tüm ihtiyaçlarınızda size özel ayrıcalıklardan yararlanabilirsiniz."
              }
          </p>
        </div>
      </section>
      <EczaciKimlikKartForm />
      <Footer />
    </div>
  );
}

export default EczaciKimlikKart;



// WEBPACK FOOTER //
// ./src/page/eczaciKimlikKart/index.js